import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '专为移动端优化的下拉式阅读体验，流畅丝滑，无需翻页等待。',
  },
  {
    icon: 'ri-paint-brush-line',
    title: '高清画质',
    desc: '全部漫画采用高清扫描，画质清晰细腻，还原每一笔线条的美感。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '同步各大平台最新连载，热门漫画第一时间更新，追更不等待。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '智能收藏',
    desc: '一键收藏喜欢的漫画，自动记录阅读进度，随时接续上次阅读位置。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="section-title">为什么选择妖精漫画</h2>
          <p className="section-subtitle">用心打造极致漫画阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg p-6 text-center transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}